import { render, staticRenderFns } from "./itexPopover.vue?vue&type=template&id=2d92f578"
import script from "./itexPopover.vue?vue&type=script&lang=js"
export * from "./itexPopover.vue?vue&type=script&lang=js"
import style0 from "./itexPopover.vue?vue&type=style&index=0&id=2d92f578&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports